var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"desc"},[_vm._v(" "+_vm._s(_vm.formatProgressText())+" ")]),_c('el-progress',{attrs:{"percentage":_vm.formatProgressPercent(),"show-text":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }